export const TIER_STYLES = {
    neutral: {
        ring: ['#4A4A4A', '#1F1F1F', '#000000'],
        glow: 'rgba(150, 150, 150, 0.20)',
        color: '#7A868B',
        chip: 'rgba(122, 134, 139, 0.16)',
    },
    bronze: {
        ring: ['#F0C08A', '#CD7F32', '#7A4A1E'],
        glow: 'rgba(205, 127, 50, 0.45)',
        color: '#CD7F32',
        chip: 'rgba(205, 127, 50, 0.16)',
    },
    silver: {
        ring: ['#FFFFFF', '#C0C0C0', '#7C8488'],
        glow: 'rgba(200, 205, 210, 0.40)',
        color: '#C8CDD2',
        chip: 'rgba(200, 205, 210, 0.14)',
    },
    gold: {
        ring: ['#FFF3A0', '#FFD700', '#B8860B'],
        glow: 'rgba(255, 215, 0, 0.50)',
        color: '#FFD700',
        chip: 'rgba(255, 215, 0, 0.16)',
    },
    diamond: {
        ring: ['#E6FBFF', '#4DD0E1', '#2E9FB0'],
        glow: 'rgba(77, 208, 225, 0.55)',
        color: '#4DD0E1',
        chip: 'rgba(77, 208, 225, 0.16)',
    },
};

const buildTiers = (thresholds) => {
    const labels = {
        neutral: 'Neutral',
        bronze: 'Bronze',
        silver: 'Silver',
        gold: 'Gold',
        diamond: 'Diamond',
    };

    const keys = ['neutral', 'bronze', 'silver', 'gold', 'diamond'];

    const thresholdsByKey =
        thresholds.length === 1
            ? Array(keys.length).fill(thresholds[0])
            : [...thresholds];

    return keys.map((key, index) => ({
        key,
        label: labels[key],
        threshold: thresholdsByKey[index],
        style: TIER_STYLES[key],
    }));
};

export const getCurrentTier = (value, tiers) => {
    let current = null;
    for (const tier of tiers) {
        if (value >= tier.threshold) {
            current = tier;
        }
    }
    return current;
};

export const getNextTier = (value, tiers) => {
    for (const tier of tiers) {
        if (value < tier.threshold) {
            return tier;
        }
    }
    return null;
};

export const getTierProgress = (value, tiers) => {
    const lastTier = tiers[tiers.length - 1];

    if (value >= lastTier.threshold) {
        return {
            percent: 100,
            from: lastTier.threshold,
            to: lastTier.threshold,
            isMaxed: true,
        };
    }

    let from = 0;
    let to = lastTier.threshold;

    for (let index = 0; index < tiers.length; index++) {
        if (value < tiers[index].threshold) {
            from = index > 0 ? tiers[index - 1].threshold : 0;
            to = tiers[index].threshold;
            break;
        }
    }

    const span = to - from;
    const percent =
        span <= 0 ? 100 : Math.min(100, Math.round(((value - from) / span) * 100));

    return { percent, from, to, isMaxed: false };
};

export const ACHIEVEMENTS_TIERS = {
    time_entries: {
        days: buildTiers([10, 100, 200, 1000, 2000]),
        meetings: buildTiers([20, 150, 300, 1000, 2000]),
        communication: buildTiers([50, 150, 300, 1000, 2000]),
        documentation: buildTiers([50, 150, 300, 1000, 2000]),
        prospection: buildTiers([50, 150, 300, 1000, 2000]),
        testing: buildTiers([50, 150, 300, 1000, 2000]),
        support: buildTiers([50, 150, 300, 1000, 2000]),
        other: buildTiers([150, 300, 1000, 2000, 3000]),
        design: buildTiers([100, 200, 1000, 2000, 3000]),
        development: buildTiers([100, 200, 1000, 2000, 3000]),
        longer_days: buildTiers([100]),
        long_meetings: buildTiers([10]),
        all_types: buildTiers([10])
    },
    projects: buildTiers([3, 6, 10, 20, 50]),
    leaves: {
        sick: buildTiers([1])
    },
    weeklies: buildTiers([10, 50, 100, 150, 300])
};
